<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    width="16px"
    height="16px"
    viewBox="0 0 32 32"
  >
    <defs>
      <linearGradient :id="`svg_star_${props.id}`">
        <stop
          :offset="`${props.percentFilled}%`"
          :stop-color="props.colorFill"
        />
        <stop
          :offset="`${100 - props.percentFilled}%`"
          stop-color="white"
        />
      </linearGradient>
    </defs>
    <path
      :fill="`url(#svg_star_${props.id})`"
      d="M20.388,10.918L32,12.118l-8.735,7.749L25.914,31.4l-9.893-6.088L6.127,31.4l2.695-11.533L0,12.118
l11.547-1.2L16.026,0.6L20.388,10.918z"
    />
  </svg>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    colorFill?: string;
    colorNotFilled?: string;
    percentFilled?: number;
    id?: string | number;
    width: string;
    height: string;
  }>(),
  {
    colorFill: '#F6D10E',
    colorNotFilled: 'var(--var-white-000)',
    percentFilled: 100,
  },
);
</script>

<style scoped lang="scss"></style>
